type Props = {
  firstName: string;
  lastName: string;
};

export const useCardHolderName = ({ firstName, lastName }: Props) => {
  const cardHolderName = [firstName, lastName]
    .map(val => {
      return val
        .trim()
        .toUpperCase()
        .replace(/[^A-Za-z]/g, '');
    })
    .filter(v => !!v)
    .join(' ');

  return {
    cardHolderName,
  };
};
